import { Actions } from './external-dashboard-settings.actions'
import { fromJS } from 'immutable'
import * as ExternalDashboardsSettingsTypes from './external-dashboard-settings.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: {},
})

export function externalDashboardsSettingsReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case ExternalDashboardsSettingsTypes.UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case ExternalDashboardsSettingsTypes.UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_SUCCESS: {
      return state.set('isLoading', false)
    }

    case ExternalDashboardsSettingsTypes.UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case ExternalDashboardsSettingsTypes.FETCH_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case ExternalDashboardsSettingsTypes.FETCH_EXTERNAL_DASHBOARDS_SETTINGS_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case ExternalDashboardsSettingsTypes.FETCH_EXTERNAL_DASHBOARDS_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case ExternalDashboardsSettingsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case ExternalDashboardsSettingsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
